module.exports = __webpack_public_path__ + "img/icon_xcx.fe50b62e.jpg";